module.exports = {
  greenDark: "#194829",
  fuchsiaLight: "#df4e96",
  aquaLightest: "#eefcf9",
  tealLightest: "#eef8fb",
  purpleLightest: "#f8f0fa",
  orangeDarker: "#441a0e",
  blueLightest: "#eef1fc",
  blueLight: "#6c8ae4",
  green: "#2f864d",
  violetDark: "#4d1fd6",
  orangeLighter: "#e69b84",
  tealLight: "#2b9abf",
  aquaLight: "#1fa888",
  purpleLight: "#bb6acd",
  fuchsiaLightest: "#fceef5",
  tealDark: "#154a5b",
  ashLightest: "#f1f2f4",
  purpleDark: "#7c2f8e",
  redLighter: "#eea0a5",
  aquaDark: "#0c4134",
  violetLight: "#9d82ed",
  white: "#ffffff",
  blueDark: "#2146b5",
  yellowLightest: "#fff8eb",
  yellowLighter: "#fdc958",
  fuchsiaDark: "#971c59",
  greenLight: "#39a25e",
  redLightest: "#fceeef",
  ashLighter: "#d8d9db",
  ashDark: "#2d333f",
  greenDarker: "#153c23",
  fuchsiaLighter: "#eb93bf",
  orange: "#c84f29",
  yellowDark: "#885e01",
  orangeLightest: "#fcf1ee",
  blueLighter: "#b1c1f1",
  red: "#da3743",
  violetDarker: "#1a0a47",
  tealLighter: "#61bddb",
  aquaLighter: "#3ddbb6",
  redDark: "#931b23",
  purpleLighter: "#d7a7e2",
  yellow: "#d99502",
  purpleDarker: "#36143d",
  aquaDarker: "#09342a",
  tealDarker: "#0f3643",
  violetLighter: "#d5c9f7",
  orangeDark: "#83331b",
  ash: "#6f737b",
  blueDarker: "#0d1b45",
  orangeLight: "#d86441",
  fuchsia: "#d82c82",
  fuchsiaDarker: "#450d29",
  greenLighter: "#64c987",
  greenLightest: "#f0faf3",
  blue: "#4a6fde",
  redLight: "#e15b64",
  ashDarker: "#141a26",
  yellowDarker: "#513701",
  teal: "#247f9e",
  aqua: "#18856b",
  purple: "#ad4cc3",
  yellowLight: "#fdaf08",
  violetLightest: "#f1edfc",
  violet: "#7f5ce8",
  ashLight: "#91949a",
  redDarker: "#450d10",
};